module.exports = __webpack_public_path__ + "static/media/paquete1.96596a72.JPG";